import React from 'react';

interface AppReviewsIconProps {
  height?: number;
  className?: string;
}

export const AppReviewsLogo: React.FC<AppReviewsIconProps> = ({
  height = 26,
  className,
}) => {
  return (
    <svg
      height={height}
      width={height}
      viewBox="0 0 192 192"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M95.6468 26.258L101.003 17.017C104.299 11.2488 111.657 9.30639 117.425 12.6025C123.193 15.8987 125.135 23.2561 121.839 29.0244L70.3372 118.197H107.595C119.662 118.197 126.43 132.382 121.192 142.211H12.0074C5.35622 142.211 0 136.855 0 130.204C0 123.553 5.35622 118.197 12.0074 118.197H42.6143L81.8148 50.2727L69.572 29.0244C66.2759 23.2561 68.2183 15.9575 73.9865 12.6025C79.7548 9.30639 87.0533 11.2488 90.4083 17.017L95.6468 26.258ZM49.3243 154.572L37.7879 174.584C34.4917 180.352 27.1343 182.295 21.366 178.999C15.5978 175.702 13.6554 168.345 16.9516 162.577L25.5451 147.744C35.198 144.742 43.0852 147.038 49.3243 154.572ZM148.738 118.256H179.993C186.644 118.256 192 123.612 192 130.263C192 136.914 186.644 142.27 179.993 142.27H162.629L174.342 162.577C177.638 168.345 175.696 175.644 169.928 178.999C164.159 182.295 156.861 180.352 153.506 174.584C133.788 140.387 118.955 114.783 109.126 97.7135C99.0607 80.3499 106.242 62.9275 113.364 57.0415C121.251 70.5792 133.023 91.0035 148.738 118.256Z"
        fill="#47474A"
      />
    </svg>
  );
};
